"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadExercises = void 0;
const react_1 = require("react");
const js_cookie_1 = __importDefault(require("js-cookie"));
const apiFetch_1 = require("@app/utils/apiFetch");
const useLoadExercises = () => {
    const [exercises, setExercises] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const language = js_cookie_1.default.get("lang_id");
        (0, apiFetch_1.apiFetch)(`/exercises/list?language=${language}`)
            .then((response) => response.json())
            .then((result) => {
            setExercises(result);
        });
    }, []);
    return exercises;
};
exports.useLoadExercises = useLoadExercises;
